// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".car-avue-data-tabs[data-v-160098a4] .avue-data-tabs .item{height:100px}.car-avue-data-tabs[data-v-160098a4] .avue-data-tabs .item-tip{top:-35px}", ""]);
// Exports
module.exports = exports;
